import { registerPlugin } from '@capacitor/core';

type Insets = { top: number; bottom: number; left: number; right: number };

export const SafeArea = registerPlugin<{
  getInsets(): Promise<Insets>;
}>('SafeArea');

// 사용 예
// const { top, bottom, left, right } = await SafeArea.getInsets();
// el.style.paddingTop = `${top}px` ...
